import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import {
  Flex,
  Stack,
  useColorModeValue,
  IconButton,
} from "@chakra-ui/react";
import {
  SettingsIcon,
} from "@chakra-ui/icons";

import { sortBy } from "lodash";

import { SiteAlarmTypes_siteAlarmTypes } from "graphql/generated";

import CardTitle from "components/card-title";

import AlarmType from "./AlarmType";


interface IProps {
  ns: string;
  name: string;
  timezone: string;
  items?: SiteAlarmTypes_siteAlarmTypes[];
  setDetailedType: (type: SiteAlarmTypes_siteAlarmTypes) => void;
  setDetailedNs: (ns: string) => void;
}


const AlarmTypeGroup: FunctionComponent<IProps> = ({
  items = [],
  ns,
  name,
  timezone,
  setDetailedType,
  setDetailedNs,
}) => {
  const intl = useIntl();
  const settingsButtonBg = useColorModeValue("white", "gray.800");

  return (
    <>
      <Stack
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        boxShadow={"xl"}
        rounded={"md"}
        m={2}
        border="3px solid"
        borderColor={useColorModeValue("gray.200", "gray.800")}
      >
        <CardTitle
          title={name}
          whiteSpace="nowrap"
        />
        <Flex
          direction="row"
          flexWrap="wrap"
          alignItems="flex-start"
          justifyContent="flex-start"
          p={2}
        >
          {sortBy(items, "name").map(alarm_type => (
            <AlarmType
              key={alarm_type.condition}
              item={alarm_type}
              timezone={timezone}
              setDetailedType={setDetailedType}
            />
          ))}
        </Flex>
        <IconButton
          aria-label="Alerts"
          bg={settingsButtonBg}
          size="sm"
          m={1}
          onClick={() => setDetailedNs(ns)}
          icon={<SettingsIcon />}
          title={intl.formatMessage({
            id: "alarms__alarm_ns__settings",
            defaultMessage: "Settings",
          })}
        />
      </Stack>
    </>
  );
};

export default AlarmTypeGroup;
